import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { auth, db } from '../firebase/config';
import { onAuthStateChanged } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { showError } from '../utils/notifications';

function PrivateRoute({ children, requiredRoles = [], requiredRole }) {
  const [isLoading, setIsLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [fetchedUserRole, setFetchedUserRole] = useState(null);

  const normalizedRequiredRoles = (Array.isArray(requiredRoles) && requiredRoles.length > 0)
    ? requiredRoles
    : (requiredRole ? [requiredRole] : []);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      console.log("🔥 PrivateRoute: onAuthStateChanged triggered. User:", currentUser ? currentUser.email : "none");
      setIsLoading(true);

      if (currentUser) {
        try {
          console.log("🔥 PrivateRoute: Verificando perfil en Firestore...");
          const userDocRef = doc(db, 'usuarios', currentUser.email);
          const userDoc = await getDoc(userDocRef);

          if (userDoc.exists()) {
            const userData = userDoc.data();
            const role = (userData.rol || 'Usuario').trim();
            setFetchedUserRole(role);
            setIsAuthenticated(true);
            console.log("🔥 PrivateRoute: Usuario autenticado y rol encontrado:", role);
          } else {
            setFetchedUserRole(null);
            setIsAuthenticated(false);
            console.log("🔥 PrivateRoute: Usuario autenticado pero no encontrado en DB.");
            showError("Usuario no encontrado", "Tu perfil no existe en el sistema");
            await auth.signOut();
          }
        } catch (error) {
          console.error("Error al verificar perfil de usuario en PrivateRoute:", error);
          setFetchedUserRole(null);
          setIsAuthenticated(false);
          showError("Error", "Ocurrió un problema al verificar tu perfil");
          await auth.signOut();
        } finally {
          setIsLoading(false);
          console.log("🔥 PrivateRoute: Chequeo de perfil completado. isLoading: false");
        }
      } else {
        setFetchedUserRole(null);
        setIsAuthenticated(false);
        setIsLoading(false);
        console.log("🔥 PrivateRoute: Usuario no autenticado. isLoading: false");
      }
    });

    return () => unsubscribe();
  }, []);

  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-screen bg-gray-100">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    console.log("🔥 PrivateRoute: Redirigiendo a /login (no autenticado)");
    return <Navigate to="/login" replace />;
  }

  if (normalizedRequiredRoles && normalizedRequiredRoles.length > 0 && fetchedUserRole !== null) {
    if (!normalizedRequiredRoles.includes(fetchedUserRole)) {
      console.log("🔥 PrivateRoute: Redirigiendo según rol");
      
      // Redirección especial para Supervisor
      if (fetchedUserRole === "Supervisor") {
        return <Navigate to="/recargas-sd" replace />;
      }

      // Redirección especial para Monitoreo
      if (fetchedUserRole === "Monitoreo") {
        return <Navigate to="/ticket-search" replace />;
      }
      
      showError("Acceso denegado", `Solo usuarios con los siguientes roles pueden acceder a esta sección: ${normalizedRequiredRoles.join(', ')}`);
      return <Navigate to="/dashboard" replace />;
    }
  }
  
  console.log("🔥 PrivateRoute: Renderizando hijos (autenticado y autorizado)");
  return children;
}

export default PrivateRoute;
